<p-sidebar
    id="schedule-courier-pick-up-drawer"
    class="custom-drawer"
    position="right"
    [visible]="isDrawerVisible()"
    [showCloseIcon]="true"
    [ariaCloseLabel]="'drawers.closeButton.ariaLabel' | translate"
    pFocusTrap
    pAutoFocus
    [autofocus]="isDrawerVisible()"
    #drawer
    (visibleChange)="checkChangesToExit($event)">
    <ng-template [pTemplate]="'header'">
        <div id="schedule-courier-pick-drawer-title">
            {{ 'dashboard.scheduleCourierPickUpDrawer.title' | translate }}
        </div>
    </ng-template>

    <div id="schedule-courier-pick-container">
        @if (!isLoading()) {
            <app-schedule-courier-pick-up-form
                [ordersList]="ordersList()"
                [locationsList]="pickupLocations()"></app-schedule-courier-pick-up-form>
        } @else {
            <app-loader [overlay]="true"></app-loader>
        }
    </div>

    <ng-template [pTemplate]="'footer'">
        <div id="schedule-courier-pick-drawer-footer">
            <p-button
                id="schedule-courier-pick-drawer-footer-cancel-button"
                [label]="'cancel' | translate"
                [outlined]="true"
                severity="secondary"
                (click)="checkChangesToExit()"></p-button>

            <div [class.disabled-element]="isLoading() || formService.getScheduleCourierForm().invalid">
                <p-button
                    id="schedule-courier-pick-drawer-footer-save-button"
                    [label]="'dashboard.scheduleCourierPickUpDrawer.submitBtn' | translate"
                    [severity]="'success'"
                    [loading]="isLoading()"
                    [disabled]="isLoading() || formService.getScheduleCourierForm().invalid"
                    (click)="saveAndClose()"></p-button>
            </div>
        </div>
    </ng-template>

    <app-pickup-submitted-modal
        [isVisible]="displayPickupSubmittedModal()"
        (isVisibleChange)="exitDrawer()"
        [pickupInfo]="scheduleCourierSubmissionModalData()"
        (scheduleAnotherPickup)="refreshScheduleCourierForm()" />

    @if (displayProgressLostWarningModal()) {
        <app-unsaved-changes-modal
            [scope]="'process'"
            [continueButtonText]="'dashboard.scheduleCourierPickUpDrawer.unsavedWarningModal.continueButton'"
            [unsavedChangesModalScopeText]="'dashboard.scheduleCourierPickUpDrawer.unsavedWarningModal.text1'"
            [unsavedChangesModalScopeText2]="'dashboard.scheduleCourierPickUpDrawer.unsavedWarningModal.text2'"
            (closeModal)="closeUnsavedChangesModal()"
            (leavePage)="exitDrawer()">
        </app-unsaved-changes-modal>
    }
</p-sidebar>
